// Height of an element pinned over the top of the viewport (e.g. an impersonation banner): the Bulkbar slides in below it.
export const BULKBAR_TOP_OFFSET_CSS_VARIABLE = "--bulkbar-top-offset";
